import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';
// Store
import { IRootState } from '../../redux';
import { Dispatch } from 'redux';
import {
    selectFolder,
    setFolderList,
    setUnreadCounter,
    setSearchValue,
    setSelectedFolderAction,
    selectMailbox,
    setUserRoles,
    setSelectSenderFolder,
    setSearchInputText,
} from '../../redux/mailbox/actions';
import { setSelectedSenderName } from '../../redux/mailbox/actions';
import { addSenderInfoList, addSenderOrganisationInfo } from '../../redux/sender/actions';
import { hideSidebar } from '../../redux/sidebar/actions';
import {
    selectMailsAction,
    setSelectedFolderMenuBarItemAction,
    setSelectedMenuBarButtonAction,
} from '../../redux/menubar/actions';
import { logoutUser } from '../../redux/user/actions';
import { getFolders } from '../../services/folder.service';
import { getAllUnreadMessagesCount } from '../../services/message.service';
import { getMailbox, getMailboxRoles } from '../../services/mailbox.service';
// Interfaces
import {
    IFolder,
    IViewFolder,
    folderActions,
    ISelectedFolder,
    IUpdatedFoldersAction,
    updateViewFolder,
    virtualFoldersEnum,
    ISenderFolder,
} from '../../interfaces/folder.interfaces';
import { IItem, IDropdownItem, ITranslateKeyError, IResponseCollection } from '../../interfaces/general.interfaces';
import { IUnreadCount, IMessage } from '../../interfaces/message.interfaces';
import { ILanguage } from '../../interfaces/globalization.interfaces';
import { IMenubarButtonAction, IMenubarFolderItemAction } from '../../interfaces/menubar.interfaces';
import { IMailBox, IUserRole } from '../../interfaces/mailbox.interfaces';
// Assets
import viewFolderStyles from './viewfolders.module.scss';
// Config
import { ConfigContext } from '../../providers';
// Enums
import { SelectAllItems, MenuBarButtonType, MoveToFolderItems, FolderTypeNames, PermissionType } from '../../enums';
// Helpers
import {
    getObjDeepCopy,
    getCurrentLanguage,
    isMediaSizeMD,
    isMediaSizeLG,
    isMediaSizeLessThanMD,
    isMediaSizeLessThanLG,
    isMediaSizeMoreThanLG,
    getFolderName,
    getVirtualFolders,
    getRootFolderFromFolderList,
    isSystemFolder,
    getUserRoleOwnerAsDropDownItem,
    getFilteredUserRoles,
    isAllowed,
    getSenderInfo,
    updateStorageMailIdFolderId,
    isAccessPrivilageWriteOnly,
    getSenders,
} from '../../helpers';
import FolderItem from './FolderItem';
import { CustomLink, Dropdown, ScrollView } from '..';
import SenderView from './SenderView/SenderView';
import images from '../../assets/images/images';
import { Image } from '..';
import { getOrganisationsBySearchValue } from '../../services';
import { IOrganisationIdent, ISenderInfo, ISenderOrganizationInfo, ISenderRequest } from '../../interfaces';

interface IViewFoldersState {
    folders: Array<IViewFolder>;
    showLinks: boolean;
    selectedFolderId?: string;
    rootFolderId: string;
    isFoldersToggle: boolean;
    isSendersToggle: boolean;
}

interface IViewFolderProps extends WrappedComponentProps, RouteComponentProps {
    isMailbox?: boolean;
}

const systemFolderSortOrder = [
    FolderTypeNames.ROOT,
    FolderTypeNames.INBOX,
    FolderTypeNames.UNREAD,
    FolderTypeNames.FLAGGEDFOLDER,
    FolderTypeNames.DRAFT,
    FolderTypeNames.SENT,
    FolderTypeNames.TRASH,
    FolderTypeNames.MORE,
];

const urlSearchParams = new URLSearchParams(window.location.search);
const isFolderRedirect = urlSearchParams.get('isFolderRedirect');
const folderRedirectParams = JSON.parse(decodeURIComponent(isFolderRedirect));

class ViewFolders extends React.Component<ReduxType, IViewFoldersState> {
    private maxFolderLevels = isMediaSizeLessThanMD(this.props.mediaSize) ? 5 : 4;

    constructor(props: ReduxType) {
        super(props);
        this.state = {
            folders: [],
            showLinks: false,
            selectedFolderId: null,
            rootFolderId: null,
            isFoldersToggle: true,
            isSendersToggle: true,
        };
    }

    componentDidMount() {
        if (!isFolderRedirect) {
            updateStorageMailIdFolderId('folderTypeOwner');
        }
        if (!this.props.searchEnabledOutsideMailbox) {
            this.props.setSearchValue('');
        }
        this.getFolders(true, { action: updateViewFolder.default, folderId: null });
        if (this.props.location.pathname !== '/mailbox') {
            getMailboxRoles(null).then((res) => {
                this.props.setUserRoles(res.items);
            });
        }
        this.props.senderOrganizationList?.length === 0 && this.setState({ isSendersToggle: false });
    }

    componentDidUpdate(prevProps: ReduxType) {
        let bFoldersLoaded: boolean;
        if (
            prevProps.senderOrganizationList.length !== this.props.senderOrganizationList?.length &&
            this.props.senderOrganizationList?.length > 0
        ) {
            this.setState({ isSendersToggle: true });
        }
        if (prevProps.mailboxId && prevProps.mailboxId !== this.props.mailboxId) {
            this.loadFoldersOnRoleChange(this.props.mailboxId, true, {
                action: updateViewFolder.default,
                folderId: null,
            });
        }

        if (prevProps.mediaSize !== this.props.mediaSize) {
            if (isMediaSizeLG(this.props.mediaSize) && this.props.sidebarShown) {
                this.props.hideSidebar();
            }
            if (isMediaSizeLessThanMD(this.props.mediaSize) !== isMediaSizeLessThanMD(prevProps.mediaSize)) {
                this.getFolders(true, { action: updateViewFolder.default, folderId: null });
                bFoldersLoaded = true;
            }
        }

        if (
            !bFoldersLoaded &&
            this.props.foldersUpdateAction &&
            (this.props.foldersUpdateAction.action === updateViewFolder.default ||
                !prevProps.foldersUpdateAction ||
                this.props.foldersUpdateAction.folderId !== prevProps.foldersUpdateAction.folderId)
        ) {
            this.getFolders(true, this.props.foldersUpdateAction, true);
            bFoldersLoaded = true;
        }

        if (!bFoldersLoaded && !prevProps.supportedLanguages && this.props.supportedLanguages) {
            if (this.props.foldersUpdateAction && this.props.foldersUpdateAction.action !== updateViewFolder.default) {
                this.getFolders(true, this.props.foldersUpdateAction, true);
            } else {
                this.getFolders(true, { action: updateViewFolder.default, folderId: null });
            }
        }

        if (this.props.selectedFolder) {
            if (
                prevProps.selectedFolder &&
                prevProps.selectedFolder.id !== this.props.selectedFolder.id &&
                this.props.selectedFolder.id !== this.state.selectedFolderId
            ) {
                this.setState({ selectedFolderId: this.props.selectedFolder.id });
                const folderData = {
                    id: this.props.selectedFolder.id,
                    name: this.props.selectedFolder.name,
                    parentId: this.props.selectedFolder.parentId,
                    mailboxId: '',
                    isActive: false,
                    folderType: '',
                    version: 0,
                };

                this.setActiveFolderClick(folderData);
            }
            if (
                prevProps.isSenderClicked !== this.props.isSenderClicked &&
                prevProps.senderInfo !== this.props.senderInfo
            ) {
                if (this.props.isSenderClicked) {
                    this.props.setSelectedSenderName(this.props.senderInfo, true);
                } else {
                    this.props.setSelectedSenderName(null, false);
                }
            }
        } else if (this.state.selectedFolderId) {
            this.setState({ selectedFolderId: null });
        }
    }

    getFolders = (reloadCall: boolean, updateAction: IUpdatedFoldersAction, forceGetData = false) => {
        const mailboxId = this.props.mailboxId || localStorage.getItem('mailboxId');

        if (mailboxId) {
            if (forceGetData) {
                this.loadFolders(mailboxId, reloadCall, updateAction);
            } else if (!this.useCachedFoldersIfPresent(reloadCall, updateAction)) {
                this.loadFolders(mailboxId, reloadCall, updateAction);
            }
        }
    };

    loadFolders = (mailboxId: string, reloadCall: boolean, updateAction: IUpdatedFoldersAction) => {
        // To manage the gap between Api and updated db Api calls
        setTimeout(() => {
            (async function () {
                return await Promise.all([getFolders(mailboxId)]);
            })().then((results) => {
                const result = results.map((item) => {
                    const folderItems = item.items.find((itm: any) => itm.folderType === FolderTypeNames.INBOX);
                    if (this.props.selectedSender != null) {
                        const result = getSenderInfo(this.props.selectSenderFolder.originalRecords);

                        this.props.setSelectSenderFolder({
                            ...this.props.selectSenderFolder,
                            folderRecords: [...result],
                        });
                    } else {
                        this.props.setSelectSenderFolder({
                            ...this.props.selectSenderFolder,
                            folderInfo: folderItems,
                        });
                    }
                    return !isAccessPrivilageWriteOnly(this.props.access?.privileges)
                        ? [
                              ...item.items,
                              {
                                  id: `${folderItems.id}_`,
                                  name: 'ulæst',
                                  parentId: folderItems.parentId,
                                  mailboxId: folderItems.mailboxId,
                                  isActive: true,
                                  folderType: FolderTypeNames.UNREAD,
                                  version: folderItems.version,
                              },
                              {
                                  id: 'FlaggedFolder_',
                                  name: 'Flagged',
                                  parentId: folderItems.parentId,
                                  mailboxId: folderItems.mailboxId,
                                  isActive: true,
                                  folderType: FolderTypeNames.FLAGGEDFOLDER,
                                  version: folderItems.version,
                              },
                          ]
                        : [...item.items];
                });

                const cleanFolderList = result[0] as IFolder[];
                this.props.setFolderList(cleanFolderList);
                const folderList = result[0] as IFolder[];
                this.constructFolders(folderList);
                this.setFolderAction(reloadCall, updateAction, folderList);
            });
        }, 1000);
    };

    loadFoldersOnRoleChange = (mailboxId: string, reloadCall: boolean, updateAction: IUpdatedFoldersAction) => {
        (async function () {
            return await Promise.all([getFolders(mailboxId), getAllUnreadMessagesCount(mailboxId)]);
        })().then((result) => {
            const folderItems = result[0].items.find((itm) => itm.folderType === FolderTypeNames.INBOX);
            if (this.props.selectedSender != null) {
                const result = getSenderInfo(this.props.selectSenderFolder.originalRecords);
                this.props.setSelectSenderFolder({
                    ...this.props.selectSenderFolder,
                    folderRecords: [...result],
                });
            } else {
                this.props.setSelectSenderFolder({
                    ...this.props.selectSenderFolder,
                    folderInfo: folderItems,
                });
            }
            const newResult = [
                ...result[0].items,
                {
                    id: `${folderItems.id}_`,
                    name: 'ulæst',
                    parentId: folderItems.parentId,
                    mailboxId: folderItems.mailboxId,
                    isActive: true,
                    folderType: FolderTypeNames.UNREAD,
                    version: folderItems.version,
                },
                {
                    id: 'FlaggedFolder_',
                    name: 'Flagged',
                    parentId: folderItems.parentId,
                    mailboxId: folderItems.mailboxId,
                    isActive: true,
                    folderType: FolderTypeNames.FLAGGEDFOLDER,
                    version: folderItems.version,
                },
            ];
            const cleanFolderList = getObjDeepCopy(newResult) as IFolder[];
            this.props.setFolderList(cleanFolderList);
            const folderList = getObjDeepCopy(newResult) as IFolder[];
            this.props.setUnreadCounter(result[1]);
            this.constructFolders(folderList);
            this.setActiveFolder(this.getInboxFolder(folderList));
        });
    };

    setFolderAction = (reloadCall: boolean, updateAction: IUpdatedFoldersAction, folderList: IFolder[]) => {
        if (reloadCall) {
            if (updateAction.action === updateViewFolder.default) {
                // if (sessionStorage.getItem('selectedFolderId')) {
                //     const previousSelectedFolderId = sessionStorage.getItem('selectedFolderId');
                //     let folderToSelect = folderList.find((folder) => {
                //         return folder.id === previousSelectedFolderId;
                //     });
                //     if (!folderToSelect) {
                //         folderToSelect = this.getInboxFolder(folderList);
                //     }
                //     this.setActiveFolder(folderToSelect);
                // } else {

                if (isFolderRedirect) {
                    this.setActiveFolder(
                        folderList.find((folder) => {
                            return folder.id === folderRedirectParams.fid;
                        })
                    );
                } else {
                    if (!this.props.selectedFolder || this.props.selectedFolder.id === undefined) {
                        this.setActiveFolder(
                            isAccessPrivilageWriteOnly(this.props.access?.privileges)
                                ? this.getDraftFolder(folderList)
                                : this.getInboxFolder(folderList)
                        ); // set inbox as active folder
                    } else {
                        this.setActiveFolder(
                            folderList.find((folder) => {
                                return folder.id === this.props.selectedFolder.id;
                            }) === undefined
                                ? this.getInboxFolder(folderList)
                                : folderList.find((folder) => {
                                      return folder.id === this.props.selectedFolder.id;
                                  })
                        ); // set selected folder as active folder
                    }
                }
                // }
            } else {
                const activeFolder = folderList.find((folder: IFolder) => {
                    return folder?.id === updateAction.folderId;
                });
                if (activeFolder) {
                    this.setActiveFolder(activeFolder);
                }
            }
        }
    };

    useCachedFoldersIfPresent = (reloadCall: boolean, updateAction: IUpdatedFoldersAction) => {
        const cachedFolderList = getObjDeepCopy(this.props.folders) as IFolder[];
        if (
            cachedFolderList === null ||
            cachedFolderList === undefined ||
            (cachedFolderList && cachedFolderList.length === 0)
        ) {
            return false;
        }
        const folderList = getObjDeepCopy(cachedFolderList) as IFolder[];
        this.constructFolders(folderList);
        this.setFolderAction(reloadCall, updateAction, folderList);
        return true;
    };

    getInboxFolder = (folderList: IFolder[]) => {
        return folderList.find((folder) => {
            return folder.folderType === FolderTypeNames.INBOX;
        });
    };

    getDraftFolder = (folderList: IFolder[]) => {
        return folderList.find((folder) => {
            return folder.folderType === FolderTypeNames.DRAFT;
        });
    };

    isCustomFolders = () => {
        return !!this.props.folders.find((folder) => {
            return folder.folderType === FolderTypeNames.CUSTOM;
        });
    };

    sortFolders = (folders: IFolder[]): IFolder[] => {
        const sortedFolders: IFolder[] = [];
        const systemFolders = folders.filter((value: IFolder) => {
            return (
                value.folderType !== FolderTypeNames.CUSTOM &&
                (value.isActive || value.folderType === FolderTypeNames.ROOT)
            );
        });

        systemFolders.forEach((folder, index) => {
            const sortIndex = systemFolderSortOrder.indexOf(folder.folderType as FolderTypeNames);
            if (sortedFolders.length > 0) {
                const lesserThanIndex = sortedFolders.findIndex((sortedFolder, sortedIndex) => {
                    return systemFolderSortOrder.indexOf(sortedFolder.folderType as FolderTypeNames) > sortIndex;
                });

                if (lesserThanIndex === -1) sortedFolders.push(folder);
                else sortedFolders.splice(lesserThanIndex, 0, folder);
            } else {
                sortedFolders.push(folder);
            }
        });

        let currentLanguage: ILanguage = null;
        if (this.props.supportedLanguages.length > 0) {
            currentLanguage = getCurrentLanguage(this.props.supportedLanguages, this.props.currentLanguageId);
        }

        const customFolders = folders
            .filter((value: IFolder) => {
                return value.folderType === FolderTypeNames.CUSTOM && value.isActive;
            })
            .sort(function (a, b) {
                return a.name.localeCompare(b.name, currentLanguage ? currentLanguage.isoCode : 'en');
            });

        customFolders.forEach((folder, index) => {
            sortedFolders.splice(sortedFolders.length, 0, folder);
        });
        return sortedFolders;
    };

    constructFolders = (folderList: Array<IFolder>) => {
        // get root folder, there can only be 1
        const rootFolder = getRootFolderFromFolderList(folderList);

        const folderListCopy = JSON.parse(JSON.stringify(folderList));

        this.setState({ rootFolderId: rootFolder.id });
        const rootViewFolder: IViewFolder = {
            name: rootFolder.name,
            id: rootFolder.id,
            parentId: rootFolder.parentId,
            level: 0,
            showChildren: true,
            children: [],
            folderType: '',
            isActive: false,
            mailboxId: null,
            version: 0,
        };

        const isCustomFolders = this.isCustomFolders();
        //folderList.push(getVirtualFolders(this.props.mailboxId, rootFolder.id, [virtualFoldersEnum.UNREAD_FOLDER])[0]);
        //folderList.push(getVirtualFolders(this.props.mailboxId, rootFolder.id, [virtualFoldersEnum.DELETE_FOLDER])[0]);
        if (isMediaSizeLessThanMD(this.props.mediaSize) && isCustomFolders) {
            folderListCopy.push(
                getVirtualFolders(this.props.mailboxId, rootFolder.id, [virtualFoldersEnum.MORE_FOLDERS])[0]
            );
        }

        const sortedFolderList = this.sortFolders(folderListCopy);

        if (isMediaSizeLessThanMD(this.props.mediaSize) && isCustomFolders) {
            sortedFolderList.forEach((folder) => {
                if (folder.parentId === rootFolder.id && folder.folderType === FolderTypeNames.CUSTOM) {
                    folder.parentId = virtualFoldersEnum.MORE_FOLDERS;
                }
            });
        }
        this.buildFolderTree(sortedFolderList, rootViewFolder, 0);
        // get folders that belongs to root
        this.setState({ folders: rootViewFolder.children }, () => {
            this.props.isMailbox && this.expandActiveFolder();
        });
    };

    buildFolderTree = (sourceFolders: Array<IFolder>, parentFolder: IViewFolder, level: number) => {
        // get folders that belongs to parentFolder
        const childFolders = sourceFolders.filter((value: IFolder) => {
            return value.parentId === parentFolder.id;
        });

        childFolders.forEach((folder, index) => {
            const newFolder: IViewFolder = {
                name: folder.name,
                id: folder.id,
                parentId: folder.parentId,
                level: level + 1,
                showChildren: level >= this.maxFolderLevels,
                children: [],
                folderType: folder.folderType,
                isActive: folder.isActive,
                mailboxId: folder.mailboxId,
                version: folder.version,
            };
            parentFolder.children.push(newFolder);
            this.buildFolderTree(sourceFolders, newFolder, level + 1);
        });
    };

    toggleLinks = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState({
            showLinks: !this.state.showLinks,
        });
    };

    expandActiveFolder = () => {
        let selectedFolderId = this.props.selectedFolder ? this.props.selectedFolder.id : null;
        if (this.state.folders && this.state.folders.length === 0) return;
        if (!selectedFolderId) {
            if (sessionStorage.getItem('selectedFolderId')) {
                selectedFolderId = sessionStorage.getItem('selectedFolderId');
            } else {
                return;
            }
        }
        const expandedFolders: IViewFolder[] = getObjDeepCopy(this.state.folders);
        if (selectedFolderId && expandedFolders) {
            this.gatherFolderPath(selectedFolderId, expandedFolders);
            this.setState({ folders: expandedFolders });
        }
    };

    getFolder = (targetFolderId: string, folder: IViewFolder): IViewFolder => {
        if (folder.id === targetFolderId) {
            if (folder.level <= this.maxFolderLevels) {
                folder.showChildren = folder.children.length > 0;
            }
            return folder;
        } else if (folder.children.length) {
            let result: IViewFolder = null;
            for (let index = 0; result === null && index < folder.children.length; index++) {
                result = this.getFolder(targetFolderId, folder.children[index]);
            }
            return result;
        }

        return null;
    };

    gatherFolderPath = (targetFolderId: string, expandedFolders: IViewFolder[]) => {
        let expandedFolder: IViewFolder = null;
        for (let index = 0; index < expandedFolders.length; index++) {
            expandedFolder = this.getFolder(targetFolderId, expandedFolders[index]);
            if (expandedFolder && expandedFolder.id === targetFolderId) break;
        }

        if (expandedFolder && expandedFolder.id !== null && expandedFolder.id !== virtualFoldersEnum.MORE_FOLDERS) {
            this.gatherFolderPath(expandedFolder.parentId, expandedFolders);
        }
    };

    setActiveFolder = (folder: IFolder) => {
        if (this.state.selectedFolderId !== folder?.id || this.props.searchValue) {
            if (this.state.selectedFolderId !== folder?.id) {
                this.setState({ selectedFolderId: folder?.id });
            }
        }
        if (this.props.selectFolder) {
            this.selectFolderInStore(folder);
        }
    };

    selectFolderInStore = (folder: IFolder) => {
        this.props.selectFolder({
            id: folder?.id || '',
            parentId: folder?.parentId || '',
            name: getFolderName(folder, this.props.intl.formatMessage) || '',
        });

        this.props.selectMailsAction(SelectAllItems.NONE);
    };

    toggleParent = (folderChanged: IViewFolder, e: React.MouseEvent) => {
        if (e !== null) {
            e.stopPropagation();
        }
        this.toggleFolder(folderChanged);
    };

    toggleFolder = (folderChanged: IViewFolder) => {
        if (folderChanged.level > this.maxFolderLevels) return;
        folderChanged.showChildren = !folderChanged.showChildren;
        this.updateFolder(folderChanged);
    };

    updateFolder = (folderToUpdate: IViewFolder) => {
        const foldersState = getObjDeepCopy(this.state.folders);
        this.searchFolder(folderToUpdate, foldersState);
        this.setState({ folders: foldersState });
    };

    searchFolder = (folderToSearch: IViewFolder, foldersList: Array<IViewFolder>) => {
        for (let folder of foldersList) {
            if (folder.id === folderToSearch.id) {
                folder = folderToSearch;
                break;
            }
            if (folder.children.length > 0) this.searchFolder(folderToSearch, folder.children);
        }
    };

    renderFolders = (folders: Array<IViewFolder>, customFoldersEnabled: boolean) => {
        const folderElements: JSX.Element[] = [];
        if (this.props.access) {
            customFoldersEnabled = isAllowed(this.props.access, PermissionType.FOLDEREXCEPTDELETE);
        }
        this.gatherFolders(folders, 0, folderElements, customFoldersEnabled);
        return folderElements;
    };

    getSeparator = (className: string, key: string) => {
        return (
            <div key={'folderSeparator' + key} className={['ml-4 mr-3', className].join(' ')}>
                <hr className={viewFolderStyles.divider} />
            </div>
        );
    };

    setActiveFolderClick = (folder: IFolder) => {
        if (
            this.state.selectedFolderId !== folder.id ||
            this.props.selectedSender != null ||
            this.props.searchValue ||
            this.props.history.location.pathname != '/mailbox'
        ) {
            this.props.setSearchInputText('');
            this.props.setSearchValue('');

            if (folder.id === virtualFoldersEnum.MORE_FOLDERS) {
                const foldersState = this.state.folders.filter((folder) => {
                    return folder.id === virtualFoldersEnum.MORE_FOLDERS;
                });
                if (foldersState[0]) {
                    this.toggleFolder(foldersState[0]);
                }
                return;
            }

            if (this.props.sidebarShown) {
                this.props.hideSidebar();
            }
            if (!this.props.isMailbox || this.props.history.location.pathname != '/mailbox') {
                this.selectFolderInStore(folder);
                this.props.history.push('/mailbox');
            } else {
                this.setActiveFolder(folder);
                this.props.setSelectedSenderName(null, false);
            }
            // this.props.selectedSender != null &&
            //     this.props.setSelectSenderFolder({
            //         ...this.props.selectSenderFolder,
            //         folderRecords: [
            //             ...this.props.selectSenderFolder.folderRecords.filter(({ isActive }) => isActive !== true),
            //             { isActive: false },
            //         ],
            //     });
        }
    };

    handleDragMoveMessages = (action: MoveToFolderItems, folderId: string) => {
        this.props.setSelectedFolderMenuBarItemAction({ action: action, folderId: folderId });
    };

    handleDragDeleteMessages = (action: MenuBarButtonType, viewedDocument: IMessage) => {
        this.props.setSelectedMenuBarButtonAction({ action: action, viewedDocument: viewedDocument });
    };

    gatherFolders = (
        folders: Array<IViewFolder>,
        level: number,
        folderElements: JSX.Element[],
        customFoldersEnabled: boolean
    ) => {
        const { rootFolderId } = this.state;
        const setActiveFolderClick = (folder: IFolder) => this.setActiveFolderClick(folder);
        const toggleParentClick = (folder: IViewFolder, e: React.MouseEvent) => this.toggleParent(folder, e);
        folders.forEach((folder, index) => {
            if (folder.isActive) {
                if (folder.folderType === FolderTypeNames.CUSTOM && !customFoldersEnabled) {
                    return;
                }

                if (
                    folder.folderType === FolderTypeNames.CUSTOM &&
                    customFoldersEnabled &&
                    folder.parentId === rootFolderId &&
                    (isMediaSizeMoreThanLG(this.props.mediaSize) || this.props.sidebarShown) &&
                    !folderElements.find((separator) => separator.key === 'folderSeparatorF1')
                ) {
                    folderElements.push(this.getSeparator(`py-2 ${viewFolderStyles.separator}`, 'F1'));
                    folderElements.push(
                        <div className={`ml-2 mr-3 py-2 pr-3 ${viewFolderStyles.separator}`}>
                            <button
                                className={`bg-none border-0 d-flex flex-row align-items-center text-left ${viewFolderStyles.vfBtn}`}
                                onClick={() => this.setState({ isFoldersToggle: !this.state.isFoldersToggle })}
                            >
                                <Image
                                    src={this.state.isFoldersToggle ? images.expandDarkSmall : images.collapseDarkSmall}
                                    alt="EXPAND"
                                />
                                <h3 className={`pl-3 ${viewFolderStyles.vfH3}`}>
                                    <FormattedMessage id="MAIL_FROM_PUBLIC_FOLDER_HEADING" />
                                </h3>
                            </button>
                        </div>
                    );
                }

                if (
                    folder.folderType === FolderTypeNames.CUSTOM &&
                    isMediaSizeMD(this.props.mediaSize) &&
                    !this.props.sidebarShown
                ) {
                    return;
                }
                folderElements.push(
                    <div
                        className={`${
                            (!this.state.isFoldersToggle && folder.folderType === FolderTypeNames.CUSTOM) ||
                            (isAccessPrivilageWriteOnly(this.props.access?.privileges) && folder.folderType != 'Draft')
                                ? 'd-none'
                                : ''
                        }`}
                    >
                        <FolderItem
                            isMailBox={this.props.isMailbox}
                            key={'fi' + level + '_' + folder.id}
                            folder={folder}
                            maxFolderLevels={this.maxFolderLevels}
                            level={level}
                            itemIndex={index}
                            onActiveFolderClick={setActiveFolderClick}
                            onToggleParentClick={toggleParentClick}
                            onDragDeleteMessages={this.handleDragDeleteMessages}
                            onDragMoveMessages={this.handleDragMoveMessages}
                        />
                    </div>
                );

                if (folder.children.length > 0 && folder.showChildren)
                    this.gatherFolders(
                        folder.children,
                        level < this.maxFolderLevels ? level + 1 : level,
                        folderElements,
                        customFoldersEnabled
                    );
            }
        });
    };

    createFolderHandler = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (this.props.sidebarShown) {
            this.hideSideBar();
        }
        this.props.setSelectedFolderAction(folderActions.CREATE_FOLDER);
    };

    selectedFolderAction = (action: IItem) => {
        this.props.setSelectedFolderAction(action?.value as folderActions);
        return true;
    };

    hideSideBar = () => {
        this.props.hideSidebar();
    };

    handleChangeMailbox = (action: IItem) => {
        this.props.setSelectedSenderName(null, false);
        this.loadMailbox(action?.value);
    };

    loadMailbox = (mailboxId: string) => {
        getMailbox(mailboxId, [403])
            .then((mailboxRes: IMailBox) => {
                getSenders(mailboxRes?.id).then((senderInfoList: ISenderInfo[]) => {
                    this.props.addSenderInfoList(senderInfoList);
                    const senderOrganizationIds = senderInfoList
                        .filter((item) => item.organisationId !== null)
                        .map((item) => item.organisationId)
                        .join(',');

                    const request: ISenderRequest = {
                        name: '*',
                        searchParameters: { id: senderOrganizationIds },
                        target: '',
                    };
                    if (senderOrganizationIds) {
                        getOrganisationsBySearchValue(request).then(
                            (organisations: IResponseCollection<IOrganisationIdent>) => {
                                this.props.addSenderOrganisationInfo(organisations?.items);
                            }
                        );
                    }
                });
                this.props.selectMailbox(mailboxRes);
                this.getFolders(true, { action: updateViewFolder.default, folderId: null });
            })
            .catch((errors: Array<ITranslateKeyError>) => void 0);
    };

    getfolderTranslateActions = (): Array<IDropdownItem> => {
        return [
            { key: 'MOVE_FOLDER', value: String(folderActions.MOVE_FOLDER), disabled: false },
            {
                key: 'DELETE_FOLDER',
                value: String(folderActions.DELETE_FOLDER),
                disabled: !isAllowed(this.props.access, PermissionType.FOLDERDELETE),
            },
            { key: 'RENAME_FOLDER', value: String(folderActions.RENAME_FOLDER), disabled: false },
        ];
    };

    public render() {
        return (
            <ConfigContext.Consumer>
                {(config): JSX.Element => (
                    <ScrollView verticalOnly tabIndex={-1} className={viewFolderStyles.folderScrollView}>
                        <div className="d-flex flex-column w-100">
                            {this.props.userRoles.length > 1 ? (
                                <div
                                    className={`d-flex flex-column w-100 ${
                                        this.props.sidebarShown ? '' : 'd-md-none d-lg-flex'
                                    }`}
                                >
                                    <div className="d-flex align-items-center pb-4 pt-2 px-3">
                                        <Dropdown
                                            className="w-100"
                                            initial={getUserRoleOwnerAsDropDownItem(this.props.userRoles)}
                                            ariaLabel=""
                                            translateData={false}
                                            onSelect={this.handleChangeMailbox}
                                            list={getFilteredUserRoles(this.props.userRoles)}
                                            onRoleList
                                        />
                                    </div>
                                </div>
                            ) : null}

                            <div
                                className={`${viewFolderStyles.foldersList} d-flex flex-row align-items-center p-0 col-12`}
                            >
                                <div className="d-flex flex-column p-0 col-12">
                                    {this.renderFolders(this.state.folders, config.features.folder.customFolders)}
                                </div>
                            </div>

                            {(!isMediaSizeLessThanLG(this.props.mediaSize) || this.props.sidebarShown) &&
                            config.features.folder.customFolders &&
                            !isAccessPrivilageWriteOnly(this.props.access?.privileges) ? (
                                <div
                                    className={`${viewFolderStyles.actions} d-flex align-items-center ml-4 mr-2 pb-0 pt-2 px-2`}
                                >
                                    <CustomLink
                                        disabled={
                                            !isAllowed(this.props.access, PermissionType.FOLDEREXCEPTDELETE) ||
                                            !this.props.isMailbox
                                        }
                                        onClick={this.createFolderHandler}
                                        className="mr-2"
                                    >
                                        <FormattedMessage id="CREATE_FOLDER" defaultMessage="CREATE_FOLDER" />
                                    </CustomLink>

                                    <Dropdown
                                        className={viewFolderStyles.customFolderMenuDropDown}
                                        ariaLabel="MORE_FOLDER_ACTIONS"
                                        minListWidth={130}
                                        textColor={config.colors.links.primary.color}
                                        translateData
                                        placeholder="MORE"
                                        onSelect={this.selectedFolderAction}
                                        list={this.getfolderTranslateActions()}
                                        disabled={
                                            !this.props.isMailbox ||
                                            !this.isCustomFolders() ||
                                            isSystemFolder(this.props.selectedFolder.id, this.props.folders) ||
                                            !isAllowed(this.props.access, PermissionType.FOLDEREXCEPTDELETE)
                                        }
                                    />
                                </div>
                            ) : null}
                            {this.getSeparator(`py-2 ${viewFolderStyles.separator}`, 'F1')}
                            <div
                                className={`${
                                    isAccessPrivilageWriteOnly(this.props.access?.privileges) ? 'd-none' : ''
                                }`}
                            >
                                {(isMediaSizeMoreThanLG(this.props.mediaSize) || this.props.sidebarShown) && (
                                    <div className={`ml-2 mr-3 py-2 pr-3 ${viewFolderStyles.separator}`}>
                                        <button
                                            className={`bg-none border-0 d-flex flex-row align-items-center text-left ${viewFolderStyles.vfBtn}`}
                                            onClick={() =>
                                                this.setState({ isSendersToggle: !this.state.isSendersToggle })
                                            }
                                        >
                                            <Image
                                                src={
                                                    this.state.isSendersToggle
                                                        ? images.expandDarkSmall
                                                        : images.collapseDarkSmall
                                                }
                                                alt="EXPAND"
                                            />
                                            <h3 className={`pl-3 mb-0 ${viewFolderStyles.vfH3}`}>
                                                <FormattedMessage id="SEARCH_MAIL_BY_SENDER" />
                                            </h3>
                                        </button>
                                    </div>
                                )}
                                <div className={`${!this.state.isSendersToggle ? 'd-none' : ''}`}>
                                    <SenderView
                                        onSenderChange={this.selectFolderInStore}
                                        isSideBarShown={
                                            isMediaSizeMoreThanLG(this.props.mediaSize) || this.props.sidebarShown
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </ScrollView>
                )}
            </ConfigContext.Consumer>
        );
    }
}

const mapStateToProps = ({ mailbox, sidebar, appReadouts, user, sender }: IRootState) => {
    return {
        mailboxId: mailbox.mailbox.id,
        selectedFolder: mailbox.selectedFolder,
        folders: mailbox.folderList,
        sidebarShown: sidebar.sidebarShown,
        foldersUpdateAction: mailbox.foldersUpdateAction,
        unreadCounter: mailbox.unreadCounter,
        mediaSize: appReadouts.mediaSize,
        currentLanguageId: user.languageId,
        supportedLanguages: appReadouts.supportedLanguages,
        searchValue: mailbox.searchValue,
        searchEnabledOutsideMailbox: mailbox.searchEnabledOutsideMailbox,
        userRoles: mailbox.userRoles,
        access: mailbox.mailbox.access,
        selectSenderFolder: mailbox.selectSenderFolder,
        selectedSender: mailbox.selectedSender,
        isSenderClicked: sender.isSenderClicked,
        senderInfo: sender.selectedSender,
        senderOrganizationList: sender.senderOrganizationList,
    };
};

const mapDispatcherToProps = (dispatch: Dispatch) => {
    return {
        hideSidebar: () => dispatch(hideSidebar()),
        selectFolder: (folder: ISelectedFolder) => dispatch(selectFolder(folder)),
        setFolderList: (folders: Array<IFolder>) => dispatch(setFolderList(folders)),
        setUnreadCounter: (unreadCounter: IUnreadCount) => dispatch(setUnreadCounter(unreadCounter)),
        selectMailsAction: (selectedAction: SelectAllItems) => dispatch(selectMailsAction(selectedAction)),
        setSearchValue: (value: string) => dispatch(setSearchValue(value)),
        logoutUser: () => dispatch(logoutUser()),
        setSelectedFolderAction: (folderAction: folderActions) => dispatch(setSelectedFolderAction(folderAction)),
        setSelectedFolderMenuBarItemAction: (itemAction: IMenubarFolderItemAction) =>
            dispatch(setSelectedFolderMenuBarItemAction(itemAction)),
        setSelectedMenuBarButtonAction: (buttonAction: IMenubarButtonAction) =>
            dispatch(setSelectedMenuBarButtonAction(buttonAction)),
        selectMailbox: (mailbox: IMailBox) => dispatch(selectMailbox(mailbox)),
        setUserRoles: (userRoles: IUserRole[]) => dispatch(setUserRoles(userRoles)),
        setSelectSenderFolder: (folder: ISenderFolder) => dispatch(setSelectSenderFolder(folder)),
        setSelectedSenderName: (sender: any, flag: boolean) => dispatch(setSelectedSenderName(sender, flag)),
        setSearchInputText: (text: string) => dispatch(setSearchInputText(text)),
        addSenderInfoList: (senderInfoList: ISenderInfo[]) => dispatch(addSenderInfoList(senderInfoList)),
        addSenderOrganisationInfo: (senderOrganizationList: ISenderOrganizationInfo[]) =>
            dispatch(addSenderOrganisationInfo(senderOrganizationList)),
    };
};

type ReduxType = IViewFolderProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatcherToProps>;

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatcherToProps)(ViewFolders)));
